import axios from "axios";

import { IMersDocumentApiResponse } from "Features/Vault/VaultInterfaces";

/**
 * Gets the list of MERS Appendix B document type names available for Add Document.
 * @returns A promise resolving to a sorted array of document type names.
 */
export function getMersDocumentTypes(): Promise<string[]> {
  return axios
    .get("/api/mers/document-types")
    .then((response) => response.data)
    .catch(() => axios.get("/api/v1/mers/document-types").then((response) => response.data));
}

/**
 * Submits a document to MERS via the Add Document transaction.
 * @param packageId The package (eNote) to add the document to.
 * @param documentType The MERS Appendix B document type name.
 * @param file The file to upload.
 * @param requestId Lets the API deduplicate retries.
 * @returns A promise resolving to the MERS transaction result.
 */
export function addMersDocument(
  packageId: string,
  documentType: string,
  file: File,
  requestId: string
): Promise<IMersDocumentApiResponse> {
  const form = new FormData();
  form.append("documentType", documentType);
  form.append("requestId", requestId);
  form.append("file", file, file.name);
  return axios.post(`/api/v1/packages/${packageId}/mers/documents`, form).then((response) => response.data);
}

/**
 * Reverses a prior MERS Add Document association for a supplemental document.
 * @param packageId The package (eNote) containing the document.
 * @param documentId The vault document domain id to reverse.
 * @returns A promise resolving to the MERS transaction result.
 */
export function reverseMersDocument(
  packageId: string,
  documentId: number
): Promise<IMersDocumentApiResponse> {
  return axios
    .delete(`/api/v1/packages/${packageId}/mers/documents/${documentId}`)
    .then((response) => response.data);
}
